import IntegrationCallStateOverviewResourceListResultModel from '../../generated/types/model/resource/IntegrationCallStateOverviewResourceListResultModel';

export default class IntegrationCallStateOverviewResourceListResultViewModel extends IntegrationCallStateOverviewResourceListResultModel {
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
